let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("id7ve")).then(() => parcelRequire('4AYC5'));